var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 50 50"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19407",
  transform: "translate(-163 -683)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  "data-name": "Ellipse 1430",
  transform: "translate(163 683)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 14975"
}, /*#__PURE__*/React.createElement("path", {
  d: "M173 693h30v30h-30z",
  "data-name": "Rectangle 2366"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 14874"
}, /*#__PURE__*/React.createElement("path", {
  d: "M178.764 700.497h15.181a3.286 3.286 0 0 1 3.291 3.291v3.642",
  "data-name": "Path 1715"
}), /*#__PURE__*/React.createElement("path", {
  d: "m182.23 697.031-3.466 3.466 3.466 3.466",
  "data-name": "Path 1716"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.235 715.502h-15.18a3.286 3.286 0 0 1-3.291-3.29v-3.642",
  "data-name": "Path 1717"
}), /*#__PURE__*/React.createElement("path", {
  d: "m193.769 718.968 3.466-3.466-3.466-3.466",
  "data-name": "Path 1718"
}))))));
export { SvgSwitch as ReactComponent };
export default __webpack_public_path__ + "static/media/switch.38397286d2f02fcf0e8fd5fb0a8754cf.svg";